<!-- Modal Compartir -->
<div class="modal fade" id="notificacionesModal" tabindex="-1" aria-labelledby="notificacionesModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="notificacionesModalLabel">Notificaciones {{misdatos.first_name}}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div
          #scrollContainerNotificaciones
          (scroll)="onScroll($event)"
          class="small rounded justify-content-end"
          style="height: 70vh; overflow-y: auto; overflow-x: hidden;">
          <div class="table-responsive" *ngIf="notificaciones && (notificaciones | keyvalue)?.length" >
            <table class="table table-striped table-hover w-auto">
              <thead>
                <tr>
                  <th scope="col">De</th>
                  <th scope="col">Cuando</th>
                  <th scope="col" class="w-100">Asunto</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let notificacion of filterNotificaciones(); let i = index"
                    (mouseenter)="filaHover = i"
                    (mouseleave)="filaHover = -1">
                  <td class="pointer" (click)="irPerfil(notificacion.slug)">
                    <div class="d-flex">
                      <div class="me-2 position-relative">
                        <img
                          *ngIf="notificacion?.foto_principal_thumb"
                          [src]="notificacion?.foto_principal_thumb"
                          class="rounded-circle pointer"
                          width="30"
                          [style.zIndex]="100">
                      </div>
                      <div>
                        <span [ngClass]="{'fw-bold': notificacion.bu_leido == ''}">{{notificacion.first_name}}</span>
                      </div>
                    </div>                  
                  </td>
                  <td>
                    <span [ngClass]="{'fw-bold': notificacion.bu_leido == ''}">{{notificacion.bu_fechahora | date:'dd/MM/yyyy HH:mm'}}</span>
                  </td>
                  <td class="w-100">
                    <div class="pointer" [ngClass]="{'fw-bold': notificacion.bu_leido == ''}" (click)="leerMas(notificacion)">
                      <i class="fa-solid fa-envelope text-iguau" *ngIf="notificacion.bu_leido == ''"></i>
                      <i class="fa-regular fa-envelope-open" *ngIf="notificacion.bu_leido == 'X'"></i>
                      {{notificacion.bu_asunto}}
                    </div>
                    <div class="small text-secondary" *ngIf="!notificacion?.leermas">
                      <div [innerHTML]="notificacion.bu_cuerpo_texto | truncate:30"></div>
                    </div>
                    <div class="p-1" *ngIf="notificacion?.leermas">
                      <div class="bg-white rounded p-2" [innerHTML]="notificacion.bu_cuerpo_texto"></div>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex" *ngIf="filaHover === i">
                      <div class="custom-link" (click)="borrarNotificacion(notificacion)" title="Borrar notificación"><i class="fa-regular fa-trash-can"></i></div>
                      <div class="custom-link" (click)="marcarLeido(notificacion)" title="Marcar como leído" *ngIf="notificacion.bu_leido == ''"><i class="fa-regular fa-envelope-open"></i></div>
                      <div class="custom-link" (click)="marcarLeido(notificacion)" title="Marcar como no leído" *ngIf="notificacion.bu_leido == 'X'"><i class="fa-solid fa-envelope"></i></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div *ngIf="!loading && notificaciones.length == 0" class="mt-3 text-secondary">
              <i class="fa-regular fa-envelope"></i> No hay notificaciones
            </div>
          </div>
          <div *ngIf="loading" class="mt-3">
            <span class="spinner-border spinner-border-sm text-iguau" aria-hidden="true"></span>
            <span class="text-secondary ms-1">Cargando... </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>